module.exports = __webpack_public_path__ + "img/rejection.1a9f7bb6.svg";